import { MainContentArea, ContentHeader } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { ManageSuppliersList } from "../../components/suppliers/ManageSuppliersList";
import { useRolesContext } from "../../hooks/roles/useRolesContext";
import { AddSupplierActionDropdown } from "../../components/suppliers/AddSupplierActionDropdown";

// To Do: Add BreadCrum
// Add Translation
export const ManageSuppliers: React.FC = () => {
  const { t } = useTranslation();
  const [isSupplierDrawerOpen, setIsSupplierDrawerOpen] = useState<boolean>(false);
  const [supplierIdToUpdate, setSupplierIdToUpdate] = useState<string>("");
  const { roles } = useRolesContext();

  const setOpenSupplierDrawerAndSettingValuesFunction = (drawerOpen: boolean, supplierId: string) => {
    setOpenSupplierDrawerFunction(drawerOpen);
    setSupplierIdToUpdate(supplierId);
  }

  const setOpenSupplierDrawerFunction = (drawerOpen: boolean) => {
    setIsSupplierDrawerOpen(drawerOpen);
  }



  return (
    <MainContentArea
      header={
        <ContentHeader
          title={t("managesuppliers.basic.title")}
          extra={
            <>
              {(roles.SYSTEM_SUPPLIERS_CREATE || roles.SYSTEM_SUPPLIERS_CREATE) && <AddSupplierActionDropdown
                // setOpenSupplierDrawerFunction={setOpenSupplierDrawerFunction}
                setOpenSupplierDrawerAndSettingValuesFunction={setOpenSupplierDrawerAndSettingValuesFunction}
              />
              }
              {/* {
               roles.SYSTEM_SUPPLIERS_CREATE && <AddHoopsSupplierButton
                  setIsAddHoopsSupplierDrawerOpenAction={setOpenSupplierDrawerAndSettingValuesFunction}

                />
              }
              {
               roles.SYSTEM_SUPPLIERS_CREATE && <AddThreadsSupplierButton
                  setIsAddThreadsSupplierDrawerOpenAction={setOpenSupplierDrawerAndSettingValuesFunction}
                />
              } */}

            </>
          }
        />

      }
    >

      <ManageSuppliersList
        supplierIdToUpdate={supplierIdToUpdate}

        isSupplierDrawerOpen={isSupplierDrawerOpen}
        setSupplierDrawerOpenFunction={setOpenSupplierDrawerFunction} />
    </MainContentArea>
  );
};
